"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
const ConnectedAccountProfileQuery = graphql(`
  query ConnectedAccountProfileQuery($address: Address!) {
    profileByAddress(address: $address) {
      __typename
      ... on Profile {
        address
        displayName
        imageUrl
        portfolioSummary {
          estimatedTokenValue {
            usd
          }
        }
      }
    }
  }
`);
export function useConnectedAccountProfile(address) {
  const $ = _c(9);
  const t0 = address ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      suspense: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !address;
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = {
      query: ConnectedAccountProfileQuery,
      variables: t1,
      context: t2,
      pause: t3
    };
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [t5] = useQuery(t4);
  const {
    data,
    fetching
  } = t5;
  const t6 = data?.profileByAddress?.__typename === "Profile" ? data.profileByAddress : null;
  let t7;
  if ($[6] !== fetching || $[7] !== t6) {
    t7 = {
      profile: t6,
      fetching
    };
    $[6] = fetching;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}